module.exports = function() {
  return new Worker(__webpack_public_path__ + "public/fibonacci.js");
};